import(/* webpackMode: "eager" */ "/app/apps/web/src/components/layout/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/layout/Navbar.tsx")